import * as R from 'ramda';
var parseNumber = R.when(R.complement(R.isNil), Number);
export var parseDataRange = function parseDataRange(response) {
  return R.pipe(R.pathOr('', ['headers', 'content-range']), R.match(/values (\d+)-(\d+)\/(\d+)/), R.when(R.isNil, R.always([])), R.slice(1, 4), R.map(parseNumber), function (_ref) {
    var start = _ref[0],
      end = _ref[1],
      total = _ref[2];
    if (R.any(R.anyPass([R.isNil, isNaN]))([start, end, total])) {
      return {};
    }
    var count = end - start + 1;
    return {
      count: count,
      total: total
    };
  })(response);
};